import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ModalVideo from './ModalVideo';

class ModalVideoThumbnail extends Component {
  static propTypes = {
    videoId: PropTypes.string.isRequired,
    className: PropTypes.string,
    img: PropTypes.string,
  };

  state = {
    open: false,
  };

  open = event => {
    event.preventDefault();
    this.setState(() => ({ open: true }));
  };

  close = () => {
    this.setState(() => ({ open: false }));
  };

  render() {
    const { videoId, img, className = '' } = this.props;
    const { open } = this.state;

    return (
      <div className={`modal-video-thumb ${className}`}>
        <a
          onClick={this.open}
          href="#video"
          className="modal-video-thumb-trigger"
        >
          <img src={img} alt="" />
          <span className="icon-video-play" />
        </a>

        <ModalVideo
          channel="youtube"
          isOpen={open}
          videoId={videoId}
          onClose={this.close}
        />
      </div>
    );
  }
}

export default ModalVideoThumbnail;
